import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UrlStateService {
  private previousUrl: string;
  private currentUrl: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  public preserveUtmParams() {
    this.subscribeToRouterEvents();
  }

  getPreviousUrl() {
    return this.previousUrl;
  }

  getCurrentUrl() {
    return this.currentUrl;
  }

  private subscribeToRouterEvents() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      const utmParams = this.getAndStoreParams('utm');

      if (utmParams.size > 0) {
        const newUrl = this.getUrlWithQueryParams(utmParams);
        this.replaceCurrentUrlIfNotMatchesTarget(newUrl);
      }
    });
  }

  private getUrlWithQueryParams(queryParams: Map<string, string>) {
    const searchParams = new URLSearchParams(window.location.search);

    queryParams.forEach((v, k) => {
      if (!searchParams.has(k)) {
        searchParams.set(k, v);
      }
    });

    return `${window.location.origin}${window.location.pathname}?${searchParams.toString()}${window.location.hash}`;
  }

  private replaceCurrentUrlIfNotMatchesTarget(targetUrl: string) {
    if (targetUrl !== window.location.href) {
      window.history.replaceState(null, '', targetUrl);
    }
  }

  public getAndStoreParams(paramNamePrefix: string): Map<string, string> {
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    const keys = queryParams.keys.filter((k) => k.startsWith(paramNamePrefix));
    const filteredParams: Map<string, string> = new Map();

    if (keys.length > 0) {
      this.clearSessionStorageItemsByPrefix(paramNamePrefix);
      keys.forEach((k) => {
        const value = queryParams.get(k);
        sessionStorage.setItem(k, value);
        filteredParams.set(k, value);
      });
      return filteredParams;
    }

    const sessionStorageKeys = Object.keys(sessionStorage).filter((k) => k.startsWith(paramNamePrefix));
    sessionStorageKeys.forEach((k) => filteredParams.set(k, sessionStorage.getItem(k)));

    return filteredParams;
  }

  private getSessionStorageKeysByPrefix(keyPrefix: string): string[] {
    return Object.keys(sessionStorage).filter((k) => k.startsWith(keyPrefix));
  }

  private clearSessionStorageEntriesByKey(keys: string[]) {
    keys.forEach((k) => sessionStorage.removeItem(k));
  }

  private clearSessionStorageItemsByPrefix(keyPrefix: string) {
    const keysToDelete = this.getSessionStorageKeysByPrefix(keyPrefix);
    this.clearSessionStorageEntriesByKey(keysToDelete);
  }
}
